module.exports = __webpack_public_path__ + "img/gocourt_img.b7e84bc0.png";